module.exports = __webpack_public_path__ + "static/media/ucf_logo.98a20993.svg";